<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-13 16:03:35
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterRecord\components\RosterPlan.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-14 11:58:58
-->
<template>
  <v-container fluid class="rounded-lg pa-3 white" ref="plan">
    <!-- loading -->
    <v-sheet
      class="
        loading_container
        text-center
        d-flex
        align-center
        justify-center
        fill-height
        rounded-lg
      "
      v-if="loading"
      :width="$refs['plan'].offsetWidth"
    >
      <v-progress-circular
        indeterminate
        size="20"
        width="2"
        color="primary"
      ></v-progress-circular>
    </v-sheet>
    <!-- 分页 -->
    <v-row dense no-gutters style="height: 32px" class="mb-2">
      <!-- <v-col md="2" class="pa-0"></v-col> -->
      <v-col md="12" class="text-center pa-0 align-center d-flex justify-start">
        <v-btn
          small
          color="white"
          shaped
          class="text-button text-capitalize primary--text mr-4"
          :disabled="$getDateTime(new Date(), 'YYYY-MM-DD') === curDate"
          @click="onTrigerPage(null)"
          >{{ $t("label_essweb_system_todayLabel") }}
        </v-btn>
        <v-btn
          icon
          small
          color="secondary"
          class="transparent"
          @click="onTrigerPage('red')"
        >
          <span class="material-icons-round">chevron_left</span>
        </v-btn>
        <v-sheet
          color="transparent"
          class="mx-6 text-capitalize text-button text--secondary"
        >
          {{
            $t("label_system_date_YMDLabel", {
              year: $getDateTime(startTime, "YYYY"),
              month: $getDateTime(startTime, "MM"),
              day: $getDateTime(startTime, "DD"),
            }) +
            " - " +
            $t("label_system_date_YMDLabel", {
              year: $getDateTime(endTime, "YYYY"),
              month: $getDateTime(endTime, "MM"),
              day: $getDateTime(endTime, "DD"),
            })
          }}</v-sheet
        >
        <v-btn
          icon
          small
          color="secondary"
          class="transparent"
          @click="onTrigerPage('add')"
        >
          <span class="material-icons-round">chevron_right</span>
        </v-btn>
        <v-menu
          v-model="selectedDay"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="secondary"
              class="ml-4 transparent"
              readonly
              v-bind="attrs"
              v-on="on"
            >
              <span class="material-icons-round">event</span>
            </v-btn>
          </template>
          <v-date-picker
            v-model="curDate"
            no-title
            :show-current="false"
            color="primary"
            flat
            scrollable
            :day-format="
              (date) => {
                return $getDateTime(date, 'D');
              }
            "
            :locale="defaultLang"
            @input="onSelectDay"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <!-- 日期 -->
    <v-row
      dense
      no-gutters
      style="border-bottom: 1px solid var(--main-border-color); height: 50px"
      class="pb-0"
    >
      <!-- 2021-12-06 100px->50px -->
      <v-col
        v-for="n in cycleType + 1"
        :key="n + 'col'"
        :cols="n === 1 ? 2 : undefined"
        class="text-center fill-height pa-0 align-center"
        :style="{
          borderRight: n == 1 ? '1px solid var(--main-border-color)' : 'none',
        }"
      >
        <v-card
          class="pa-0 fill-height align-end align-items-end"
          :elevation="0"
          tile
        >
          <!-- 2021-12-06 改ui false  -->
          <template v-if="n === 1 && false">
            <DateSelect
              :startTime="startTime"
              :endTime="endTime"
              :isEdited="isEdited"
              :selectStaffs="selectStaffs"
              :isActive="isActive"
              :page="page"
              :perpage="itemsPerPage"
              @search="onSearch"
              :curFilterStaff="fliterStaffs"
              :allStaffs="allStaffs"
              @onCheckAll="
                (check) => {
                  if (check) {
                    selectStaffs = allStaffs;
                    allCheck = true;
                  } else {
                    selectStaffs = [];
                    allCheck = false;
                  }
                }
              "
            />
          </template>

          <!-- @onCheckAll="(check)=>{allCheck=check}" -->
          <template v-else>
            <div class="fill-height max-width d-flex justify-end flex-column">
              <DaySelect
                :time="curPageDate[n - 2]"
                :selectStartDate="selectStartDate"
                :selectEndDate="selectEndDate"
              />
            </div>
          </template>
        </v-card>
      </v-col>
    </v-row>
    <v-container
      class="max-width pa-0 ma-0 rounded-lg scroll"
      fluid
      :style="{
        overflow: 'overlay',
        height: $vuetify.breakpoint.height - 460 + 46 + 'px',
      }"
    >
      <!-- <noContent v-if="RosterList.length <= 0" /> -->
      <!-- buglist 1526  -->
      <v-sheet v-if="RosterList.length <= 0" height="300"></v-sheet>
      <v-row
        dense
        no-gutters
        class="max-width flex-wrap"
        v-for="(tr, index) in RosterList"
        :key="index + 'roster'"
        style="height: 100px"
      >
        <v-col
          v-for="n in cycleType + 1"
          :key="n + 'col'"
          :cols="n === 1 ? 2 : undefined"
          :style="{
            borderRight: n == 1 ? '1px solid var(--main-border-color)' : 'none',
          }"
          class="text-center max-width fill-height align-center"
        >
          <shiftCard2
            :col="n"
            :roster_uuid="Roster_uuid"
            :curType="cycleType"
            :curData="tr"
            :allCheck="allCheck"
            :selectStaffs="selectStaffs"
            :isEdited="isEdited"
            @check="onCheckStaff"
            :shiftList="shiftList"
            :selectStartDate="selectStartDate"
            :selectEndDate="selectEndDate"
            :curDate="curPageDate[n - 2]"
            @onShift="toShift"
          />
        </v-col>
      </v-row>
    </v-container>
    <!-- 分页 -->
    <v-row
      dense
      v-if="RosterList.length"
      no-gutters
      class="pa-0 ma-0"
      style="border-top: 1px solid var(--main-border-color)"
    >
      <v-col
        md="12"
        class="text-center pa-0 align-center d-flex justify-center"
      >
        <v-sheet
          class="
            pa-2
            pb-0
            max-width
            d-flex
            flex-nowrap
            align-center
            justify-space-between
          "
        >
          <!-- <TableManageTools v-if="showSelect" /> -->
          <span class="text-caption text--secondary">
            {{ other }}
            {{ $t("label_essweb_list_components_pagenations_columnLabel") }}({{
              $t("label_essweb_list_components_pagenations_totalLabel")
            }}
            {{ Number(totalCount) == 0 ? RosterList.length : totalCount }}
            {{ $t("label_essweb_list_components_pagenations_columnLabel") }})
          </span>
          <v-spacer></v-spacer>
          <v-pagination
            v-model="page"
            color="grey lighten-2 "
            class="text--primary d-inline-block text-truncate text-center"
            prev-icon="navigate_before"
            next-icon="navigate_next"
            :length="
              Number(totalCount) == 0
                ? 1
                : Math.ceil(
                    totalCount /
                      (itemsPerPage == -1 ? totalCount : itemsPerPage)
                  )
            "
            :total-visible="7"
          />
          <v-spacer></v-spacer>
          <span class="text-caption text--secondary pr-1">{{
            $t("label_essweb_list_components_pagenations_perpageLabel")
          }}</span>
          <v-menu offset-y small>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                width="60"
                height="28"
                outlined
                depressed
                style="
                  border-color: rgba(0, 0, 0, 0.1) !important;
                  border-radius: 6px;
                  min-width: 60px;
                "
                class="
                  mrc-border-solid
                  text-capitalize
                  pa-0
                  white
                  text-body-2
                  d-flex
                  justify-space-around
                "
                text
              >
                {{
                  itemsPerPage == -1
                    ? $t(
                        "label_essweb_list_components_pagenations_selectNumber_allLabel"
                      )
                    : itemsPerPage
                }}
                <i class="material-icons-round">arrow_drop_down</i>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(item, index) in [10, 20, 50]"
                :key="index"
                @click="itemsPerPage = item"
              >
                <v-list-item-title>{{
                  item == -1
                    ? $t(
                        "label_essweb_list_components_pagenations_selectNumber_allLabel"
                      )
                    : item
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
    <RosterShiftDialog
      :show="showRosterShift"
      @close="
        showRosterShift = false;
        nowShow = false;
        curData = null;
      "
      :hasPermission="hasPermission"
      @onChange="controlNav"
      :curData="curData"
      @onSubmit="
        showRosterShift = false;
        nowShow = false;
        curData = null;
        getRosterList(1, itemsPerPage);
      "
    />
    <!-- Recalculate -->
    <RecalculateDialog
      :show="showRecalcul"
      :curStaffs="RosterList"
      @close="closeReculDialog"
      @onSave="toReCalGen"
    />
    <GenerateRoster
      :show="showRosterForm"
      :curStaffs="RosterList"
      :selectStaffs="selectStaffs"
      @close="closeRosterFormDialog"
      @onSave="toRosterForm"
    />
    <ExportIn
      :show="showExIn"
      @close="showExIn = false"
      @export="onExportEnd"
    />
  </v-container>
</template>
<script>
import DateSelect from "@/Page/EssAdmin/Roster/RosterRecord/components/DateSelect";
import RosterShiftDialog from "@/Page/EssAdmin/Roster/RosterRecord/components/RosterShiftDialog2";
import RecalculateDialog from "@/Page/EssAdmin/Roster/RosterRecord/components/RecalculateDialog";
import GenerateRoster from "@/Page/EssAdmin/Roster/RosterRecord/components/GenerateRoster";
import ExportIn from "@/Page/EssAdmin/Roster/RosterRecord/components/ExportIn";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import shiftCard2 from "@/Page/EssAdmin/Roster/RosterRecord/components/shiftCard2";
import DaySelect from "@/Page/EssAdmin/Roster/RosterRecord/components/DaySelect";
export default {
  name: "RosterPlan",
  components: {
    DateSelect,
    DaySelect,
    shiftCard2,
    ExportIn,
    RosterShiftDialog,
    RecalculateDialog,
    GenerateRoster,
  },
  computed: {
    ...mapGetters(["companyLang", "defaultLang"]),
    loadingHeight() {
      return $(".main-content").height();
    },
    loadingWidth() {
      return $(".main-content").width();
    },
    totalDay() {
      if (this.startTime && this.endTime) {
        return dayjs(this.endTime).diff(dayjs(this.startTime), "day") + 1;
      } else {
        return 0;
      }
    },
    allDayByPage() {
      var arr = [];
      const that = this;
      const chunk = this.cycleType;
      for (var i = 0, j = that.allDay.length; i < j; i += chunk) {
        arr.push(that.allDay.slice(i, i + chunk));
      }
      return arr;
    },
    allDay() {
      var arr = [];
      const that = this;
      if (this.startTime && this.endTime) {
        var daylen = dayjs(this.endTime).diff(dayjs(this.startTime), "day"); //总天数
        for (var i = 0; i <= daylen; i++) {
          arr.push(dayjs(that.startTime).add(i, "day").format("YYYY-MM-DD"));
        }
      }
      return arr;
    },
    curPageDate() {
      if (this.pageDate > 0) {
        return this.allDayByPage[this.pageDate - 1];
      } else {
        return this.allDayByPage[0];
      }
    },
    allStaffs() {
      let arr = [];
      this.RosterList.map((item) => {
        arr.push(Number(item.staff_id)); //2020-10-20 staff_id-->user_id//2021-11-20 user_id-->staff_id
      });
      return arr;
    },
    other() {
      let start =
        this.page == 1
          ? 1
          : Number(this.itemsPerPage) * (Number(this.page) - 1) + 1;
      let end =
        this.page == 1
          ? Number(this.itemsPerPage) * Number(this.page)
          : Number(this.itemsPerPage) * Number(this.page);
      if (Number(end) > Number(this.totalCount) || this.itemsPerPage == -1) {
        end = Number(this.totalCount);
      }
      return start + " - " + end;
    },
  },
  props: {
    cycleType: { default: 14, type: Number },
    Roster_uuid: { default: "", type: String },
    startTime: { default: "", type: String },
    isEdited: { default: false, type: Boolean },
    showExportOut: { default: false, type: Boolean },
    showExportIn: { default: false, type: Boolean },
    endTime: { default: "", type: String },
    selectStartDate: { default: "", type: String },
    selectEndDate: { default: "", type: String },
    hasPermission: { default: false, type: [Boolean, Number] },
    change: { default: 0, type: Number },
    showRecalcul: { default: false, type: Boolean },
    showRosterForm: { default: false, type: Boolean },
    filterData: { default: null, type: [Array, Object, String, Number] },
    toDo: {
      default: "",
      type: String,
    },
  },
  watch: {
    page(val) {
      if (val) this.getRosterList(val, this.itemsPerPage);
    },
    itemsPerPage(val) {
      this.getRosterList(1, val);
    },
    showExportIn(val) {
      this.showExIn = val;
    },
    showExIn(val) {
      if (!val) {
        this.$emit("closeExportIn");
      }
    },
    startTime(val) {
      this.curDate = val;
      if (val) this.getRosterList(1, this.itemsPerPage);
    },
    endTime(val) {
      // console.log(val);
    },
    isEdited(val) {
      if (!val) {
        this.selectStaffs = [];
      }
    },
    selectStartDate(val) {
      // console.log(val);
    },
    selectStaffs(val) {
      this.$emit("check", val);
    },
    filterData: {
      handler(val) {
        if (val) this.getRosterList(1, this.itemsPerPage);
      },
      deep: true,
    },
  },
  mounted() {
    this.itemsPerPage = this.$tableSetting.perPageSize;
  },
  methods: {
    onSelectDay(date) {
      this.selectedDay = false;
      this.$emit("onTrigerPage", "add", date);
    },
    onExportEnd(success) {
      if (success) this.getRosterList(1, this.itemsPerPage, true);
    },
    onSearch: function (staffs) {
      // this.fliterStaffs = staffs ? staffs : [];
      // this.getRosterList(1, this.itemsPerPage, staffs);
    },
    closeReculDialog: function () {
      this.$emit("closeCalcul");
    },
    controlNav: function (f) {
      if (!this.nowShow) {
        this.nowShow = true;
      } else {
        this.nowShow = false;
        this.showRosterShift = false;
        this.curData = null;
      }
    },
    closeRosterFormDialog: function () {
      this.$emit("closeRosterForm");
    },
    onTrigerPage: function (logic) {
      this.$emit("onTrigerPage", logic);
    },
    toShift: function (curdata, date) {
      this.curData = curdata;
      this.curData["roster_date"] = date;
      this.showRosterShift = true;
    },
    onCheckStaff: function (staffid, checked) {
      const that = this;
      if (checked) {
        that.selectStaffs.push(staffid);
      } else {
        that.selectStaffs = that.selectStaffs.filter((ele) => ele != staffid);
      }
    },

    toRosterForm: function (obj) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster/generate-roster-records/",
        data: {
          roster_form_uuid: obj.roster_form_uuid,
          roster_form_record_title: obj.roster_form_record_title,
          roster_form_record_description: obj.roster_form_record_description,
          staff_uuids: obj.staffIds.join(","),
          manager_uuids: obj.managerIds.join(","),
          // 2021-01-06 lsj
          //2020-06-04 brain lsj
          // start_time: this.$getTimeValue(this.selectStartDate),
          start_time: this.$getTimeValue(obj.start_time),
          //2020-06-04 brain lsj
          // end_time: this.$getTimeValue(this.selectEndDate),
          end_time: this.$getTimeValue(obj.end_time),
          remarks: obj.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_rosterRecord_form_dialog_rosterGeneratedSuccessLabel"
          ),
          type: "success",
        });
        that.closeRosterFormDialog();
        that.$emit("back");
        that.getRosterList(1, that.itemsPerPage, false);
      });
    },
    toReCalGen: function (staffs, start, end) {
      const that = this;
      let url = "";
      if (this.toDo == "regenerate") {
        url = "/roster/generate-roster/";
      } else {
        url = "/roster/recalculate/";
      }
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: url,
        data: {
          staff_uuids: staffs.join(","),
          start_time: this.$getTimeValue(start),
          end_time: this.$getTimeValue(end),
        },
      }).then((res) => {
        that.$showMessage({
          color: "black",
          text:
            that.toDo == "regenerate"
              ? that.$t(
                  "message_essweb_rosterRecord_form_dialog_rosterGenerateInitSuccessLabel"
                )
              : that.$t(
                  "message_essweb_rosterRecord_form_dialog_rosterRecalculateSuccessLabel"
                ),
          type: "success",
        });
        that.closeReculDialog();
        that.getRosterList(1, that.itemsPerPage, false);
      });
    },

    getRosterList(page, perpage, reset) {
      // reset重置筛选条件
      const that = this;
      this.loading = true;
      // this.RosterList = [];
      // if (this.Roster_uuid != "") {
      let data = Object.assign(
        {
          type: 2,
          start_time: this.$getTimeValue(this.startTime),
          end_time: this.$getTimeValue(this.endTime),
          cpage: page,
          pagesize: perpage,
        },
        this.filterData && !reset ? this.filterData : {}
      );
      // if (this.fliterStaffs.length > 0) {
      //   data["staff_uuid"] = this.fliterStaffs.join(",");
      // }
      // if (staffs) {
      //   data["staff_uuid"] = staffs.join(",");
      //   this.fliterStaffs = staffs ? staffs : [];
      // }
      this.isActive = Math.random() * 100000000;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster/get-roster-large-table/",
        data: data,
      })
        .then((res) => {
          that.page = page;
          that.itemsPerPage = perpage;
          that.RosterList = res.data;
          that.$emit("reset", reset);
          that.totalCount = res.totalcount;
          that.$Sleep(500).then(() => {
            that.loading = false;
          });
        })
        .catch((err) => {
          that.RosterList = [];
          that.$Sleep(500).then(() => {
            that.loading = false;
          });
          that.$showMessage({
            title: that.$t("message_essweb_form_textField_errNoticeTitle"),
            type: "error",
            text: err,
          });
        });
    },
  },
  data() {
    return {
      pageDate: 1,
      page: 1,
      showRosterShift: false,
      selectStaffs: [],
      curData: null,
      selectedDay: false,
      curDate: "",
      fliterStaffs: [],
      itemsPerPage: 20,
      totalCount: 0,
      nowShow: false,
      isActive: 0,
      showExIn: false,
      loading: false,
      allCheck: false,
      RosterList: [],
      shiftList: [],
    };
  },
};
</script>
<style scoped>
.loading_container {
  position: absolute;
  z-index: 1;
  margin-left: -12px;
  margin-top: -12px;
  background: rgba(0, 0, 0, 0.3);
}
</style>
